import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { SvgIcon } from '@progress/kendo-react-common';
import { pencilIcon } from '@progress/kendo-svg-icons';

interface EditableTitleProps {
    value: string;
    onChange: (value: string) => void;
    // Restores the last saved name when the user presses Escape
    onCancel: () => void;
    placeholder?: string;
    error?: string;
    // Rendered next to the title (e.g. a status badge)
    children?: React.ReactNode;
}

export function EditableTitle({ value, onChange, onCancel, placeholder, error, children }: EditableTitleProps) {
    const { t } = useTranslation();
    const [isRenaming, setIsRenaming] = useState(false);

    if (!isRenaming) {
        return (
            <div className="detail-title-row">
                <div className="detail-title">{value}</div>
                {children}
                <button type="button" className="icon-btn" title={t('general.rename')} onClick={() => setIsRenaming(true)}>
                    <SvgIcon icon={pencilIcon} size="small" />
                </button>
            </div>
        );
    }

    const cancel = () => { onCancel(); setIsRenaming(false); };

    return (
        <div>
            <div className="rename-row">
                <input
                    autoFocus
                    className="lm-input rename-input"
                    value={value}
                    placeholder={placeholder}
                    onChange={e => onChange(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter') setIsRenaming(false);
                        if (e.key === 'Escape') cancel();
                    }}
                />
                <button type="button" className="lm-btn-secondary sm" onClick={() => setIsRenaming(false)}>
                    <Trans>dlpConfiguration.done</Trans>
                </button>
            </div>
            {error && <div className="rename-error">{error}</div>}
        </div>
    );
}
